"use strict";
exports.__esModule = true;
var router_1 = require("@angular/router");
var claim_account_component_1 = require("./claim-account.component");
var routes = [
    {
        path: '',
        children: [
            {
                path: '',
                component: claim_account_component_1.ClaimAccountComponent,
            },
        ],
    },
];
var ClaimAccountRoutingModule = /** @class */ (function () {
    function ClaimAccountRoutingModule() {
    }
    return ClaimAccountRoutingModule;
}());
exports.ClaimAccountRoutingModule = ClaimAccountRoutingModule;
